import {useState} from 'react';
import {useNavigate} from "react-router-dom";
import {LogIn} from "react-feather";
import styled from 'styled-components';
import RightNav from './RightNav';

const StyledBurger = styled.a`
  width: 2rem;
  height: 2rem;
    //position: ${({open}) => open ? 'fixed' : 'absolute'};
  position: relative;
  top: ${({open}) => open ? '16px' : '14px'};
  right: 20px;
  z-index: 99999;
  display: flex;
  justify-content: space-around;
  flex-flow: column nowrap;

  div {
    width: 2rem;
    height: 0.25rem;
    background-color: ${({open}) => open ? '#ccc' : '#293B8D'};
    border-radius: 10px;
    transform-origin: 1px;
    transition: all 0.3s linear;

    &:nth-child(1) {
      transform: ${({open}) => open ? 'rotate(45deg)' : 'rotate(0)'};
    }

    &:nth-child(2) {
      transform: ${({open}) => open ? 'translateX(100%)' : 'translateX(0)'};
      opacity: ${({open}) => open ? 0 : 1};
    }

    &:nth-child(3) {
      transform: ${({open}) => open ? 'rotate(-45deg)' : 'rotate(0)'};
    }
  }
`;

const LogoDiv = styled.div`
  display: flex;
  justify-content: end;
  width: 100%;
  text-align: center;

  img {
    position: relative;
    top: -5px;
  }
`

const StyledLogin = styled.div`
  display: flex;
  padding: 15px 0;
  position: absolute;
  left: 0;
  color: #FF9B6B
`

const StyledLoginButton = styled.button`
  padding: 0;
  background: none;
  border: 0;
  color: inherit;

  &:active, &:focus {
    outline: 0;
  }
`

const Burger = ({logo/*, toggleModal*/}) => {
    const [open, setOpen] = useState(false);
    const navigate = useNavigate();

    const closeMenu = () => {
        setOpen(!open)
    }

    return (
        <>
            <StyledBurger open={open} onClick={() => setOpen(!open)} className={`${open === true && "mar-t"} `}  >
                <div className={`${open === true && "div-open top-ham"} div-color  `}/>
                <div className={`${open === true && "div-open"} div-color `}/>
                <div className={`${open === true && "div-open"} div-color `}/>
            </StyledBurger>
            <div>
            </div>
            {/*<LogoDiv className="logo-div" onClick={() => navigate('/')}>*/}
            {/*    {logo}*/}
            {/*</LogoDiv>*/}
            <RightNav
                open={open}
                logo={logo}
                toggle={() => closeMenu()}
            />
            {/*<StyledLogin>
                <StyledLoginButton className="mr-1" onClick={() => toggleModal()}>
                    <LogIn/>
                </StyledLoginButton>
            </StyledLogin>*/}
        </>
    )
}

export default Burger
